const  en = {
  sidebar: {
    folders: 'Folders',
    megaphonGeneral: 'Megaphon general',
    addFolder: 'Add folder',
    system: "System"
  }
}
const he = {
  sidebar: {
    folders: 'תיקיות',
    megaphonGeneral: 'מגפון כללי',
    addFolder: 'צור תיקייה',
    system: "מערכת"
  }
}
const heF = {
  ...he,
}
export const commonLocales = {
  en,
  he,
  heF
}